import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import React, {useState} from 'react';
import {Button, Col, Container, Modal, Row} from 'react-bootstrap';
import { Check, Download, X } from 'react-feather';
import {publish_report} from '../../API/report';
import CreateAdviceComponent from './CreateAdviceComponent';
import EditAdviceComponent from './EditAdviceComponent';
import IgnoreListModalComponent from './IgnoreListModalComponent';
import AdvicesComponent from './AdvicesComponent';
import KategorieComponent from './KategorieComponent';
import {updateProjectStatus} from "../../API/analysenrequestdata";
import {getOut} from "../../Utils/Common";
import {getOnlyUserEmail, sendEmail} from "../../API/user";
import { downloadDatasetAPI } from '../../API/kategories';
import RisksDetectionModal from './RisksDetectionComponent';
import AnnotationRulesetModal from './AnnotationRulesetComponent';

import Form from "react-bootstrap/Form"
//import {getOnlyUserEmail, sendEmail} from "../../API/user";

//import {getOnlyUserEmail, sendEmail} from "../../API/user";

function AnnotatorFooter(props) {
    // const [setAITrack] = useState(false);

    const [createAdviceModalShow, setCreateAdviceModalShow] = useState(false);
    const [risksDetectionModalShow, setRisksDetectionModalShow] = useState(false);
    const [annotationRulesetModalShow, setAnnotationRulesetModalShow] = useState(false);
    const [createAdviceSaveConfirmationModalShow, setCreateAdviceSaveConfirmationModalShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [valueCheckModalShow, setValueCheckModalShow] = useState(false);
    const [annotationsExistModalShow, setAnnotationsExistModalShow] = useState(false);
    const [kategorieModalShow, setKategorieModalShow] = useState(false);
    const [publishConfirmationModalShow, setPublishConfirmationModalShow] = useState(false);
    const [isPublish, setIsPublish] = useState(false);
    const [sendCustomerEmail,setSendCustomerEmail]=useState(true);

    //Components Visibility
    const [publishComponentVisibility] = useState(props.publishComponentShow);
    const [editAdviceComponentVisibility] = useState(props.editAdviceComponentShow);
    const [ignoreComponentVisibility] = useState(props.ignoreComponentShow);
    const [categoryComponentVisibility] = useState(props.categoryComponentShow);
    const [createAdviceComponentVisibility] = useState(props.createAdviceComponentShow);
    const [risksDetectionComponentVisibility] = useState(props.risksDetectionComponentShow);
    const [annotationRulesetComponentVisibility] = useState(props.annotationRulesetComponentShow);

    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff'
        }
    }));

    /*const sendAITrack = async (e) => {
		if (e.target.checked) {
			setAITrack(true);
			//get original AI annotations
			//TODO API request to output collection
			let mainAIannotations = await getAIOutputDB().then(function (result) {
				return result;
			});
			//get tracked ai annotations
			let trackedAIannotations = await getAITracking().then(function (result) {
				return result;
			});

			let mainAI = mainAIannotations[0].annotation_data;
			let trackedAI = trackedAIannotations[0].trackingInfo.tracking_info;
			//loop over original AI annotations for getting the true positive
			for (let [key, value] of Object.entries(mainAI)) {
				if (key in trackedAI) {
					console.log(value);
					//only take the false positive tracked uptill now
					let trackedAIfalsePositive = trackedAI[key].fp;
					//let copyoftrackedAIfalsePositive = trackedAIfalsePositive
					let result = [];
					result = mainAI[key].filter(function (o1) {
						return !trackedAIfalsePositive.some(function (o2) {
							return (
								JSON.stringify(o1['Annotation'].trim()) ===
									JSON.stringify(o2.annotation_data['Annotation'].trim()) &&
								JSON.stringify(o1['norm']) === JSON.stringify(o2.annotation_data['norm']) &&
								JSON.stringify(o1['advice']) === JSON.stringify(o2.annotation_data['advice'])
							);
						});
					});
					trackedAI[key].tp = result;
				} else {
					trackedAI[key] = { tp: mainAI[key], fp: [], fn: [] };
				}
			}
			console.log(123, trackedAI);
			getTrackAItoBackend(trackedAIannotations[0].trackingInfo.lv_id, trackedAI);
		}
	};*/

    const classes = useStyles();

    function AdvicesModal(propsAdviceModal) {
        return (
            <Modal {...propsAdviceModal} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Advices Katalog</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AdvicesComponent advicecatalog={[]} lvid={props.lvid}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={propsAdviceModal.onHide}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    function CreateAdviceModal(propsCreateAdviceModal) {
        return (
            <Modal {...propsCreateAdviceModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Create Advice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreateAdviceComponent/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-group-sm" variant="outline-dark" onClick={propsCreateAdviceModal.onHide}>
                        <X/>
                        Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    /**
     *  When the Analyst confirms publish, it sets the 'Gut Gemacht' visibility to true.
     */
    const handlePublishConfirmationClick = async (e) => {
        // Verify for unresolved annotations
        //const lvID = localStorage.getItem('parsedlv_id');
        let lvID = props.lvid
        const projectName = localStorage.getItem('projectName');
        const firm = props.projectFirm;
        const baseURL = process.env.REACT_APP_FRONTEND_BASE_URI;
        let annotations = props.annotationData.annotations
        // let isEmpty = annotations.forEach((obj) => {
        //     if (obj.adviceID === "" || obj.adviceID === null || obj.adviceID === undefined) {
        //         return true
        //     } else {
        //         return false
        //     }
        // })
        // alert(isEmpty)

        function isEmpty(value) {
            return value === null || value === undefined || value === '';
        }

        const hasEmpty = annotations.some(obj => isEmpty(obj.adviceID));

        if(!hasEmpty){
        //if (document.querySelectorAll('*[class="inValidation"]').length === 0) {
            e.preventDefault();
            // Circle Loading Animation - Stops
            setIsPublish(true);
            let attributes = {lv_id: lvID, projectName: projectName, projectFirm: firm, baseURL: baseURL};
            //save_before_publish(extractedAnnotationsData);
            let returnValue = await publish_report(attributes)
            if (returnValue.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
            }
            // .then(async(response) => {
            //     // Circle Loading Animation - Stops
            //     setIsPublish(false);
            //     await updateProjectStatus(lvID, "Completed")
            //     return response.json();
            // })
            // .catch((error) => {
            //     // Circle Loading Animation - Stops
            //     setIsPublish(false);
            //     console.error('Error:', error);
            // });
            if (returnValue !== null) {

                let updateResult = await updateProjectStatus({"uploadlv_id": lvID, "status": "Completed"})
                if (updateResult.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                    getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
                }

            if(sendCustomerEmail) {
                let userData = await getOnlyUserEmail(props.projectuploader)
                // let emaildetails = {
                //     user_name: userData.fn + " " + userData.ln,
                //     proj_name: projectName,
                //     purpose: "report",
                //     report_link: returnValue.response.reportURL
                // }
                // await sendEmail(userData.useremail, emaildetails)
                let emaildetails = {
                    emailtype: "report",
                    emaildetails: {
                        email: userData.useremail,
                        username: userData.username,
                        projectname: projectName,
                        reportlink: returnValue.response.reportURL
                    }
                }
                await sendEmail(emaildetails)
            }

                localStorage.setItem('showGutGemacht', 'YES');
                sessionStorage.setItem('link', returnValue.response.reportURL);
            }
            window.location.reload();


        } else {
            alert('Please resolve all annotations.There are some annotations without adviceId.');
            setIsPublish(false);
        }
        localStorage.removeItem('projectName')
    };

    function downloadDataset() {
        let filename = '';
        downloadDatasetAPI().then(async response => {
            const baseName = "dataset"
            const extension = "xlsx";
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const dateTimeString = `${day}${month}${year}_${hours}${minutes}${seconds}`;
            filename = `${baseName}_${dateTimeString}.${extension}`;

            const byteArray = await response.arrayBuffer();

            return new Blob([byteArray], { type: response.headers.get('Content-Type') });
        }).then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element
        })
            .catch(error => {
                console.error(error);
            });
    }

    function KategorieModal(propsKategorieModal) {
        return (
            <Modal {...propsKategorieModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Handwai | Position Kategorie</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <KategorieComponent/>
                </Modal.Body>
                <Modal.Footer>
                    <Button size="lg" variant="outline-dark" block onClick={propsKategorieModal.onHide}>
                        <X/> Abbrechen
                    </Button>
                    <Button size="lg" variant="outline-dark" block onClick={() => downloadDataset()}>
                        <Download/> Download training dataset
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <>
            <Container fluid>
                <Row>
                    {publishComponentVisibility && (
                        <Col>

                            <a
                                className="btn handwai-btn-create"
                                rel="noreferrer"
                                onClick={() => setPublishConfirmationModalShow(true)}
                            >
                                {' '}
                                Publish
                            </a>
                            )
                        </Col>
                    )}
                    {editAdviceComponentVisibility && (
                        <Col>
                            <EditAdviceComponent/>
                        </Col>
                    )}
                    {ignoreComponentVisibility && (
                        <Col>
                            <IgnoreListModalComponent/>
                        </Col>
                    )}
                    {categoryComponentVisibility && (
                        <Col>
                            <Button onClick={() => setKategorieModalShow(true)} className="handwai-btn-create">
                                Kategorie
                            </Button>
                        </Col>
                    )}
                    {createAdviceComponentVisibility && (
                        <Col>
                            <Button onClick={() => setCreateAdviceModalShow(true)} className="handwai-btn-create">
                                Create New Advice
                            </Button>
                        </Col>
                    )}
                    {risksDetectionComponentVisibility && (
                        <Col>
                            <Button onClick={() => setRisksDetectionModalShow(true)} className="handwai-btn-create">
                                Risks Detection
                            </Button>
                        </Col>
                    )}
                    {annotationRulesetComponentVisibility && (
                        <Col>
                            <Button onClick={() => setAnnotationRulesetModalShow(true)} className="handwai-btn-create">
                                Annotations Ruleset
                            </Button>
                        </Col>
                    )}


                   <Col>
                       <Form>

          <Form.Check
              className="form-check-input-lg"
            label={"Email Schicken"}
              checked={sendCustomerEmail}
              onChange={(e)=>{
                  setSendCustomerEmail(e.target.checked)
              }}
            type={"checkbox"}
              style={{color:"white",fontSize:20,transform:40}}
          />
                       </Form>
                   </Col>


                </Row>
            </Container>

            <Modal
                show={createAdviceSaveConfirmationModalShow}
                onHide={() => setCreateAdviceSaveConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bitte bestätigen Sie</Modal.Title>
                </Modal.Header>
                <Modal.Body>Möchten Sie wirklich neue Advice hinzufügen? </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-success">
                        <Check/>
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setCreateAdviceSaveConfirmationModalShow(false)}>
                        <X/>
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={createAdviceSaveConfirmationModalShow}
                onHide={() => setCreateAdviceSaveConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Bitte bestätigen Sie</Modal.Title>
                </Modal.Header>
                <Modal.Body>Möchten Sie wirklich neue Advice hinzufügen? </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-success">
                        <Check/>
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setCreateAdviceSaveConfirmationModalShow(false)}>
                        <X/>
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>

            <AdvicesModal show={modalShow} onHide={() => setModalShow(false)}/>

            <CreateAdviceModal show={createAdviceModalShow} onHide={() => setCreateAdviceModalShow(false)}/>

            <RisksDetectionModal show={risksDetectionModalShow} onHide={() => setRisksDetectionModalShow(false)}/>

            <AnnotationRulesetModal show={annotationRulesetModalShow} onHide={() => setAnnotationRulesetModalShow(false)}/>

            <KategorieModal show={kategorieModalShow} onHide={() => setKategorieModalShow(false)}/>

            <Modal
                show={valueCheckModalShow}
                onHide={() => setValueCheckModalShow(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Lieber Roman, lieber Andreas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Nicht jedes Potenzial, Risiko hat einen Wert Oder es wurde kein Hinweis ausgewählt. Bitte prüfen
                        Sie die Zusammenfassung für weitere Hinweise.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="btn-group-sm"
                        variant="outline-dark"
                        onClick={() => {
                            setValueCheckModalShow(false);
                            window.location.reload();
                        }}
                    >
                        <X/>
                        Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={annotationsExistModalShow}
                onHide={() => setValueCheckModalShow(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Lieber Roman, lieber Andreas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Keine Annotierungen vorhanden!</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="btn-group-sm"
                        variant="outline-dark"
                        onClick={() => {
                            setAnnotationsExistModalShow(false);
                            window.location.reload();
                        }}
                    >
                        <X/>
                        Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={publishConfirmationModalShow}
                onHide={() => setPublishConfirmationModalShow(false)}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title> Bitte bestätige </Modal.Title>
                </Modal.Header>

                <Modal.Body>Willst du den Report wirklich veröffentlichen?</Modal.Body>

                {/*<Modal.Body>
                    Willst du den AI Track data speichern? {'    '}
                    <input
                        onChange={(e) => sendAITrack(e)}
                        className="userdetailscheckbox"
                        type="checkbox"
                        id="aiTrackConfirm"
                    />
                </Modal.Body>
*/}
                <Modal.Footer>
                    <Button
                        //disabled={!aiTrack}
                        variant="outline-success"
                        onClick={handlePublishConfirmationClick}
                    >
                        <Check/>
                        Ja! Ich bestätige.
                    </Button>
                    <Button variant="outline-dark" onClick={() => setPublishConfirmationModalShow(false)}>
                        <X/>
                        Nein
                    </Button>
                </Modal.Footer>
            </Modal>

            {isPublish ? (
                <Backdrop className={classes.backdrop} open>
                    <CircularProgress color="inherit"/>
                </Backdrop>
            ) : (
                ''
            )}
        </>
    );
}

export default AnnotatorFooter;
